import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FacilitySearchService, ProviderSearchService } from '../api/services';

/**
 * This module intercepts outgoing calls and replaces the endpoints for provider and facility searches with the APIM roots retrieved from the configuration.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiBaseInterceptorService implements HttpInterceptor {
  endpointsToOverride: string[];
  constructor() {
    // programmatically build endpoints to override
    this.endpointsToOverride = [
      ...Object.getOwnPropertyNames(ProviderSearchService)
        .filter((prop) => typeof (ProviderSearchService as any)[prop] === "string")
        .map((prop) => (ProviderSearchService as any)[prop]),
    
      ...Object.getOwnPropertyNames(FacilitySearchService)
      .filter((prop) => typeof (FacilitySearchService as any)[prop] === "string")
      .map((prop) => (FacilitySearchService as any)[prop])
    ];
  }

  /**
   * The override of the interception logic. 
   * Which is to replace the base part of the API calls with the root of the APIM end point 
   * read from the environments object.
   * @param req http request object.
   * @param next the next http handler of the pipeline.
   * @returns the pipeline of http handlers
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // get apim base uri
    const baseUri = environment.apimOverrideUri

    // ET: for the detail calls, the path is a pattern which contains token {uid}
    // see if request has a match in our overridable endpoints
    const match = this.endpointsToOverride.find(endpointPattern => new RegExp(endpointPattern.replace('{uid}', '[\\w%]+')).test(req.url));

    if(baseUri !== '' && match){
      const rootUrlPattern = /^https?:\/\/[^\/]+\/api/;
      const endpoint = req.url.replace(rootUrlPattern, '');

      const newReq = req.clone({
        url: baseUri + endpoint
      });

      return next.handle(newReq);
    }

    return next.handle(req);
  }
}
